import actionTypes from './actionTypes';
import APIs from '../../apis';
import { action, generateErrorAction } from '../../redux/actions';

export const getAdsList = query => {
  return dispatch => {
    dispatch(action(actionTypes.GET_ADS_LIST_LOADING));
    return APIs.ads
      .getAdsList(query)
      .then(response => {
        dispatch(action(actionTypes.GET_ADS_LIST_SUCCESS, response));
        console.log('response', response);
      })
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_ADS_LIST_FAILED,
            reject: actionTypes.GET_ADS_LIST_REJECT
          })
        );
        console.log(err);
      });
  };
};

export const addAd = ad => {
  return dispatch => {
    dispatch(action(actionTypes.ADD_AD_LOADING));

    return APIs.ads
      .add(ad)
      .then(response => {
        dispatch(action(actionTypes.ADD_AD_SUCCESS, response));
      })
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.ADD_AD_FAILED,
            reject: actionTypes.ADD_AD_REJECT
          })
        );
      });
  };
};

export const changeAdVisibility = (id, visibility) => {
  return dispatch => {
    dispatch(action(actionTypes.CHANGE_AD_VISIBILITY_LOADING));
    return APIs.ads
      .changeAdVisibility(id, visibility)
      .then(response => {
        dispatch(
          action(actionTypes.CHANGE_AD_VISIBILITY_SUCCESS, {
            id,
            isVisible: visibility
          })
        );
      })
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.CHANGE_AD_VISIBILITY_FAILED,
            reject: actionTypes.CHANGE_AD_VISIBILITY_REJECT
          })
        );
      });
  };
};

export const deleteAd = id => {
  return dispatch => {
    dispatch(action(actionTypes.DELETE_AD_LOADING));

    return APIs.ads
      .deleteAd(id)
      .then(response => {
        dispatch(
          action(actionTypes.DELETE_AD_SUCCESS, {
            id
          })
        );
      })
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.DELETE_AD_FAILED,
            reject: actionTypes.DELETE_AD_REJECT
          })
        );
      });
  };
};

export const defaultAd = ad => {
  return dispatch => {
    dispatch(action(actionTypes.DEFAULT_AD_LOADING));
    return APIs.ads
      .defaultAd(ad)
      .then(response => {
        dispatch(action(actionTypes.DEFAULT_AD_SUCCESS, { ad }));
      })
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.DELETE_AD_FAILED,
            reject: actionTypes.DEFAULT_AD_REJECT
          })
        );
      });
  };
};
